// extracted by mini-css-extract-plugin
export default {"ECBCard":"ECB_ECBCard__6d8Lq","ECBImage":"ECB_ECBImage__gdCPV","ECBCardBody":"ECB_ECBCardBody__LU7-t"};